import { dashboardPath } from "./dashboard/path";

import { authManagementPath } from "@routes/authManagement/path";
import { usersPath } from "@routes/userManagement/users/path";
import { teachersPath } from "@routes/userManagement/teachers/path";
import { studentsPath } from "@routes/userManagement/students/path";
import { assistantsPath } from "@routes/userManagement/assistants/path";
import { adminsPath } from "@routes/userManagement/admins/path";
import { courseManagementPath } from "@routes/courseManagement/path";
import { trainingCourseManagementPath } from "@routes/trainingCourseManagement/path";
import { trainingCourseAssistantManagementPath } from "@routes/trainingCourseAssistantManagement/path";
import { codeManagementPath } from "@routes/codeManagement/path";
import { contentManagementPath } from "@routes/contentManagement/path";
import { onlineExamManagementPath } from "@routes/onlineExamManagement/path";
import { descriptiveExamManagementPath } from "@routes/descriptiveExamManagement/path";
import { channelManagementPath } from "@routes/channelManagement/path";
import { commentManagementPath } from "@routes/commentManagement/path";
import { teacherRankPath } from "@routes/teacherRank/path";
import { passwordPath } from "@routes/userManagement/password/path";
import { binaryQuestionPath } from "@routes/binaryQuestions/path";
import { multipleChoiceQuestionPath } from "@routes/multipleChoiceQuestions/path";
import { notificationManagementPath } from "@routes/notification/path";
import { messagesManagementPath } from "@routes/messages/path";
import { teacherListPath } from "@routes/student/teacherList/path";
import { trainingCourseListPath } from "@routes/student/trainingCourseList/path";
import { myTrainingCourseListPath } from "@routes/student/myTrainingCourseList/path";
import { myChannelListPath } from "@routes/student/myChannelList/path";
import { studentNotificationsPath } from "@routes/student/notification/path";
import { studentMessagesPath } from "@routes/student/messages/path";
import { profilePath } from "@routes/student/profile/path";
import { studentSettingsPath } from "@routes/student/settings/path";
import { popularCoursesPath } from "@routes/pupularCourses/path";
import { settingsPath } from "@routes/settings/path";
import { chatManagementPath } from "@routes/chat/path";
import { supportPath } from "@routes/support/path";
import { myStudentsCoursesPath } from "@routes/myStudentsCourses/path";
import { myExamsPath } from "@routes/student/myExams/path";
import { myTeachersPath } from "@routes/myTeachers/path";
import { studentEmailVerificationPath } from "@routes/student/emailVerification/path";
import { contactManagementPath } from "@routes/contactManagement/path";
import { blogPostPath } from "@routes/blogPost/path";

export type { IDashboardRouteParams } from "./dashboard/path";

export const routePath = removePathSuffix({
  dashboardPath,
  authManagementPath,
  userManagement: {
    usersPath,
    teachersPath,
    studentsPath,
    assistantsPath,
    adminsPath,
    passwordPath,
  },
  courseManagementPath,
  trainingCourseManagementPath,
  trainingCourseAssistantManagementPath,
  codeManagementPath,
  contentManagementPath,
  onlineExamManagementPath,
  descriptiveExamManagementPath,
  channelManagementPath,
  commentManagementPath,
  teacherRankPath,
  binaryQuestionPath,
  multipleChoiceQuestionPath,
  notificationManagementPath,
  messagesManagementPath,
  popularCoursesPath,
  settingsPath,
  chatManagementPath,
  supportPath,
  myStudentsCoursesPath,
  myTeachersPath,
  contactManagementPath,
  blogPostPath,
  student: {
    teacherListPath,
    trainingCourseListPath,
    myTrainingCourseListPath,
    myChannelListPath,
    studentNotificationsPath,
    studentMessagesPath,
    profilePath,
    settingsPath: studentSettingsPath,
    myExamsPath,
    studentEmailVerificationPath,
  },
} as const);

type IRemovePathSuffix<T> = {
  [K in keyof T as K extends `${infer Key}Path` ? Key : K]: T[K] extends (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args: any[]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => any
    ? T[K]
    : T[K] extends object
      ? IRemovePathSuffix<T[K]>
      : T[K];
};

function removePathSuffix<T extends object>(obj: T): IRemovePathSuffix<T> {
  const result = {} as IRemovePathSuffix<T>;

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const newKey = key.endsWith("Path")
        ? (key.slice(0, -4) as keyof IRemovePathSuffix<T>)
        : (key as keyof IRemovePathSuffix<T>);
      const value = obj[key];

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (result as any)[newKey] =
        typeof value === "object" &&
        value !== null &&
        !Array.isArray(value) &&
        typeof value !== "function"
          ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
            removePathSuffix(value as any)
          : value;
    }
  }

  return result;
}
